<!--入场&出场过度动画-->
<template>
    <div style="margin: auto;
    color: #000000;
    background-color: #ff8282;
    height: 25px;
    line-height: 25px;
    text-align: center;
    border-radius: 25px;
    width: 80px">
      欢迎!
    </div>
</template>

<script>
export default {
  name: "ComeIn"
}
</script>

<style scoped>

</style>
